import Table, { dateFormatter } from "../../../components/tables/table";

export default function ProjectSection({ customer, setCustomer }) {

    const columns = [
        { dataField: "title", text: "Project name", sort: true },
        {
            dataField: "createdAt",
            text: "Created at",
            formatter: dateFormatter,
            sort: true,
        },
        { dataField: "_id", text: "", formatter: (cell) => "", headerStyle: { width: '100px' } }
    ];

    return (
        <>
            <Table data={customer.projects || []} columns={columns} />
        </>
    );
}